import React, { Component } from 'react';

class EditGrafico extends Component {
    state = {  }
    render() { 
        return (
            <div>Editar Diseño Gráfico</div>
        );
    }
}
 
export default EditGrafico;


// WEBPACK FOOTER //
// ./src/views/WebMaster/EditGrafico.jsx